module.exports = __webpack_public_path__ + "img/20220622102444.47f6a6e8.png";